export var parentLinks = {
    FINDACAR: "Find a car",
    PARTEXCHANGE: "Part exchange",
    CARCARE: "Car care",
    CARFINANCE: "Car finance",
    HOWCINCHWORKS: "How cinch works"
};
